export default __webpack_public_path__ + "static/media/TF4-1.836154bc.jpg";